module.exports = __webpack_public_path__ + "img/pr-2.5cc8b8e6.png";